import { instances } from '@/services/http';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import type {
  UserDashboardSubmitUgcPublicationRequestType,
  UserDashboardSubmitUgcPublicationResponseType,
} from '@magma-app/magma-types/user-dashboard/ugc';

export const useSubmitPublication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UserDashboardSubmitUgcPublicationRequestType) => {
      const { userUgcId, ...body } = payload;
      const response = await instances.userDashboard.put(
        `ugcs/${userUgcId}/publication`,
        body
      );

      return response.data as UserDashboardSubmitUgcPublicationResponseType;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ugcs'] });
    },
  });
};
